export const borders = [
  {
    id: 300001,
    borderId: 500001,
    name: "پایانه مرزی باشماق",
    contour: [
      [
        45.9932327,
        35.6346976
      ],
      [
        46.0021591,
        35.5777542
      ],
      [
        46.1079025,
        35.5470326
      ],
      [
        46.0989761,
        35.6531117
      ],
      [
        46.0491943,
        35.6801673
      ]
    ]
  },
  {
    id: 500002,
    borderId: 500002,
    name: "پایانه مرزی تمرچین",
    contour: [
      [
        45.0551033,
        36.695952
      ],
      [
        45.0908088,
        36.7126048
      ],
      [
        45.1153564,
        36.6842516
      ],
      [
        45.1332092,
        36.650517
      ],
      [
        45.1251411,
        36.6231054
      ],
      [
        45.0556182,
        36.6397739
      ]
    ]
  },
  {
    id: 1,
    name: "پایانه مرزی خسروی",
    borderId: 2,
    contour: [
      [
        45.46468734741212,
        34.39487037448104,
      ],
      [
        45.46623229980469,
        34.38382103873294
      ],
      [
        45.472240447998054,
        34.375887282939466
      ],
      [
        45.48477172851563,
        34.38523770174096
      ],
      [
        45.48511505126954,
        34.39529531980665
      ],
      [
        45.47618865966797,
        34.40209415157199
      ],
      [
        45.46468734741212,
        34.394870374481044
      ]
    ]
  },
  {
    id: 250001,
    name: "پایانه مرزی مهران",
    borderId: 1,
    contour: [
      [
        46.05331420898438,
        33.1276324009696
      ],
      [
        46.03975296020508,
        33.09513691979034
      ],
      [
        46.09485626220704,
        33.087946030485995
      ],
      [
        46.122150421142585,
        33.07341864032515
      ],
      [
        46.12180709838868,
        33.11713738719689
      ],
      [
        46.092281341552734,
        33.120731711214255
      ],
      [
        46.0679054260254,
        33.12791991794054
      ],
      [
        46.05331420898438,
        33.1276324009696
      ]
    ]
  },
  {
    id: 500001,
    name: "پایانه مرزی شلمچه",
    borderId: 3,
    contour: [
      [
        48.02690505981446,
        30.519237636201616
      ],
      [
        48.05368423461914,
        30.515244816150467
      ],
      [
        48.06501388549805,
        30.497644877268996
      ],
      [
        48.05728912353516,
        30.487290484252792
      ],
      [
        48.034629821777344,
        30.48862182508258
      ],
      [
        48.02570343017579,
        30.489509375517002
      ],
      [
        48.02690505981446,
        30.519237636201616
      ]
    ]
  },
  {
    id: 750001,
    borderId: 4,
    name: "پایانه مرزی چذابه",
    contour: [
      [
        47.81044006347656,
        31.8813476157784
      ],
      [
        47.80048370361328,
        31.866769945358534
      ],
      [
        47.802543640136726,
        31.850440216816747
      ],
      [
        47.80769348144532,
        31.84256592152673
      ],
      [
        47.82932281494141,
        31.830315681768262
      ],
      [
        47.8451156616211,
        31.806393860756764
      ],
      [
        47.86296844482422,
        31.786259723197066
      ],
      [
        47.87738800048829,
        31.78246584395653
      ],
      [
        47.876701354980476,
        31.825065081208855
      ],
      [
        47.8670883178711,
        31.87376751498619
      ],
      [
        47.81044006347656,
        31.8813476157784
      ]
    ]
  },
  {
    id: 1250001,
    borderId: null,
    name: "قصر شیرین",
    contour: [
      [
        45.5599594116211,
        34.527489999202025

      ],
      [
        45.555839538574226,
        34.504010311590385
      ],
      [
        45.56922912597657,
        34.485617985056834
      ],
      [
        45.593605041503906,
        34.48759889206494
      ],
      [
        45.61042785644532,
        34.50287859326337
      ],
      [
        45.60836791992188,
        34.520984242501534
      ],
      [
        45.60665130615235,
        34.5328639366582
      ],
      [
        45.582618713378906,
        34.53569218549074
      ],
      [
        45.5599594116211,
        34.527489999202025
      ]
    ]
  },
  {
    id: 1500001,
    borderId: null,
    name: "مهران",
    contour: [
      [
        46.23836517333985,
        33.218584491237785
      ],
      [
        46.15425109863282,
        33.120012858178534
      ],
      [
        46.161117553710945,
        33.110523446688916
      ],
      [
        46.3070297241211,
        33.089240433964726
      ],
      [
        46.309432983398445,
        33.10707249744481
      ],
      [
        46.25072479248047,
        33.21542502259453
      ],
      [
        46.23836517333985,
        33.218584491237785
      ]
    ]
  },
  {
    id: 1750001,
    name: "خرمشهر",
    borderId: null,
    contour: [
      [
        48.15547943115235,
        30.536242254734933
      ],
      [
        48.10913085937501,
        30.462583411533927
      ],
      [
        48.187065124511726,
        30.395087872483607
      ],
      [
        48.28662872314453,
        30.501046794453146
      ],
      [
        48.246116638183594,
        30.55043513509528
      ],
      [
        48.15547943115235,
        30.536242254734933
      ]
    ]
  }
]